(ns journal-app-client.db
  (:require [journal-app-client.routes :as routes]))

(defonce default-db
  (let [query-map (routes/uri->query-map)
        initial-view (or (:view (get routes/setup (keyword (:view query-map)))) :home)
        initial-props {:sub-view (keyword (:sub-view query-map))}]
    {:config                  {:locale    "en-US"
                               :time-zone "Europe/Oslo"}
     :selected-view           [initial-view initial-props]
     :query-map               query-map}))
